import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { CURP } from '@domain/interfaces/otros.interface';

@Injectable()
export class OtherService {
  public url: string;
  public urlSucursal: string;

  constructor(
    public _http: HttpClient
  ) {
    this.url = environment.otoscat + 'valueset/';
    this.urlSucursal = environment.getSocio;

  }

  catGetValueSet(): Observable<any> {
    let ruta = this.url + 'getAll'; 
    return this._http.get(ruta);
  }

  catSearchSet(text: string): Observable<any> {
    let ruta = this.url + 'getByName/' + text; 
    return this._http.get(ruta);
  }

  getSocio(id: any): Observable<any> {
    let ruta = this.urlSucursal + "/" + id;
    return this._http.get(ruta);
  }

  getSocioNumber(number: any): Observable<any> {
    let ruta = environment.getSocioNumber + "/" + number;
    return this._http.get(ruta);
  }

  obtenerLike(text: any) {
    return this._http.get<CURP[]>(environment.obtenrLike + text)
      .toPromise()
      .then(res => { return <CURP[]>res; });
  }

  catGetById(): Observable<any> {
    let ruta = this.url + 'getById/';
    return this._http.get(ruta);
  }

  catUpdate(request: any): Observable<any> {
    let ruta = this.url + 'Update/' + request.id; 
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(ruta, params, { headers: headersResp });
  }

  catCreate(request: any): Observable<any> {
    let ruta = this.url + 'Create'; 
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  private mostrarTablaSubject: Subject<boolean> = new Subject<boolean>();
  mostrarTabla$ = this.mostrarTablaSubject.asObservable();

  mostrarTabla(valor: boolean): void {
    this.mostrarTablaSubject.next(valor);
  }
}